import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { ReportLastLocationAllVINsDTO } from "src/app/features/map-features/sections/locations-section/models/ReportLastLocationAllVINsDTO";
import { CatalogPaginationRequest } from "../../models/CatalogPagination/CatalogPaginationRequest";
import { FilterRequest } from "../../models/Filter/FilterRequest";
import { IApiBase } from "./Interface/IApiBase.interface";
import { EstatusJSON } from "../../models/EstatusJSON";

@Injectable({
  providedIn: "root",
})
export class ReportsAPIService implements IApiBase {

  configUrl: string;
  constructor(private http: HttpClient) {
    this.configUrl = environment.host;
  }

  delete(id: any) {
    throw new Error("Method not implemented.");
  }
  insert() {
    throw new Error("Method not implemented.");
  }
  update(datos: any) {
    throw new Error("Method not implemented.");
  }
  getFilterValues(request: FilterRequest[]) {
    throw new Error("Method not implemented.");
  }
  getPage(pageRequest: CatalogPaginationRequest) {
    throw new Error("Method not implemented.");
  }
  getCount(pageRequest: CatalogPaginationRequest) {
    throw new Error("Method not implemented.");
  }

  postLocationsTabToExcel(selectedTab, idLocationCategory, finder, filtersRequest) {
    return this.http.post<EstatusJSON>(
      this.configUrl + "/api/Reports/PostLocationsTabToExcel", {
        selectedTab,
        idLocationCategory,
        finder,
        filtersRequest
      }
    );
  }

  postLocationsByIdentifiersToExcel(identifiers: string[]) {
    return this.http.post<EstatusJSON>(
      this.configUrl + "/api/Reports/PostLocationsByIdentifiersToExcel", {
        identifiers
      }
    );
  }

  getReportLastLocationsAllVINs() {
    return this.http.get<EstatusJSON>(
      this.configUrl + "/api/Reports/GetReportLastLocationsAllVINs", {}
    );
  }

  getReportLocationInventory() {
    return this.http.get<EstatusJSON>(
      this.configUrl + "/api/Reports/GetReportLocationInventory", {}
    );
  }
}
